import * as PIXI from "pixi.js";
import Game from "../../Game";
import Layers from "../../layers/Layers";
import TextureManager from "../../managers/TextureManager";
import InfoSliderBody from "./InfoSliderBody";
import InfoSliderArrows from "./InfoSliderArrows";
import InfoSliderDot from "./InfoSliderDot";
import { INFO_SLIDER_DIMS } from "../../types/Config";
import { Coord } from "../../types/Interface";


export default class InfoSlider extends PIXI.Container {
  static instance: InfoSlider;
  private Game = Game.getInstance();
  private Layers: Layers = Layers.getInstance();
  private infoSliderDims = INFO_SLIDER_DIMS;
  private infoSliderAssets: string[];
  private InfoSliderDots: InfoSliderDot[] = [];
  constructor(coord: Coord) {
    super();
    if (!InfoSlider.instance) {
      InfoSlider.instance = this;
    }
    Object.assign(this, coord);
    this.infoSliderAssets = TextureManager.getInfoSliderAssetURLs();
    this.isPortial();


    new InfoSliderArrows(this.infoSliderDims);
    new InfoSliderBody(this.infoSliderAssets, this.infoSliderDims);
    this.addDots();
    this.addToLayer();
  }
  static getInstance = () => InfoSlider.instance;
  private addToLayer = () => this.Layers.UI.addChild(this);

  private isPortial() {
    const dim = this.Game.getDim();
    if (dim.WIDTH > dim.HEIGHT) {
      return
    }
    this.x = dim.WIDTH / 2;
    this.y = this.infoSliderDims.height / 2 + 50;
    this.scale.set(1.3)
  }
  private addDots() {
    const lenghtISA = this.infoSliderAssets.length;
    this.infoSliderAssets.forEach((a, aI) => {
      const even = lenghtISA % 2 == 1 ? true : false;
      const x = (aI - (lenghtISA / 2) + (even ? .5 : .5)) * 30;
      const dot = new InfoSliderDot(aI, x, this.infoSliderDims);
      this.InfoSliderDots.push(dot);
    })
  }
}